// extracted by mini-css-extract-plugin
export var productImage = "_pc-1";
export var viewLink = "_pc-2";
export var wishlistItem = "_pc-0";